export const CACHE_CONFIG = {
  latestTracksLimit: 3000,
  latestTracksPrefetch: 100,

  nftEventsCacheTime: 1000 * 60 * 60 * 24, // 24h
} as const;
